import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is stored in localStorage
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      const nextUser =
        parsedUser?.account_type === 'actor' && parsedUser?.name === 'Demo Actor'
          ? { ...parsedUser, name: 'Nivin Pauly' }
          : parsedUser;

      if (nextUser !== parsedUser) {
        localStorage.setItem('user', JSON.stringify(nextUser));
      }

      setUser(nextUser);
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const updateUser = (updates) => {
    setUser((current) => {
      const nextUser = current ? { ...current, ...updates } : current;
      if (nextUser) {
        localStorage.setItem('user', JSON.stringify(nextUser));
      }
      return nextUser;
    });
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  const value = {
    user,
    login,
    updateUser,
    logout,
    loading,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
